import { Currency } from '@/core/currency/interfaces';

const MVR: Currency = {
    name: 'Maldivian Rufiyaa',
    demonym: 'Maldivian',
    majorSingle: 'Rufiyaa',
    majorPlural: 'Rufiyaa',
    codeNumeric: '462',
    symbol: 'MRf',
    symbolNative: '.ރ',
    minorSingle: 'laari',
    minorPlural: 'laari',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'MVR',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default MVR;
